import { useQuery } from '@tanstack/react-query';
import { listMine } from '../services/userDevices';
import { useAuth } from './useAuth';

export function useMyDevices() {
  const { isAuthenticated } = useAuth();
  return useQuery({
    queryKey: ['me', 'devices'],
    queryFn: listMine,
    enabled: isAuthenticated,
  });
}
